/* Bundle strip — copy the discount code.
   Delegated from the document, so a strip rendered inside a section that the
   theme editor re-renders keeps working without rebinding. */
(function () {
  'use strict';

  function flash(btn, message) {
    var value = btn.querySelector('.cbs__value');
    var label = btn.querySelector('.cbs__label');
    if (!value || !label) return;

    if (btn.dataset.cbsBusy) return;
    btn.dataset.cbsBusy = '1';

    var wasValue = value.textContent;
    var wasLabel = label.textContent;
    label.textContent = message;
    value.textContent = btn.dataset.cbsCode;
    btn.classList.add('is-copied');

    var live = btn.parentNode.querySelector('.cbs__live');
    if (live) live.textContent = message + ' ' + btn.dataset.cbsCode;

    setTimeout(function () {
      label.textContent = wasLabel;
      value.textContent = wasValue;
      btn.classList.remove('is-copied');
      if (live) live.textContent = '';
      delete btn.dataset.cbsBusy;
    }, 1600);
  }

  // Older Safari and any non-secure context have no clipboard API, so fall
  // back to selecting a throwaway input and letting execCommand do it.
  function legacyCopy(text) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(field);
    return ok;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cbs-code]');
    if (!btn) return;
    e.preventDefault();

    var code = btn.dataset.cbsCode;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(
        function () { flash(btn, 'Copied'); },
        function () { flash(btn, legacyCopy(code) ? 'Copied' : 'Copy failed'); }
      );
    } else {
      flash(btn, legacyCopy(code) ? 'Copied' : 'Copy failed');
    }
  });
})();
